import { ActionButton } from "./ActionButton";
import { AddToBagButton } from "./AddToBagButton";
import React from "react";

type MenuItemCardActionsProps = {
  menuItemId: number;
  defaultVariantId: number;
  pickupEnabled: boolean;
};

export const MenuItemCardActions: React.FC<MenuItemCardActionsProps> = ({
  menuItemId,
  defaultVariantId,
  pickupEnabled,
}) => {
  return (
    <div className="flex flex-grow justify-center items-center -mx-xs">
      {pickupEnabled ? (
        <>
          <ActionButton variant="tertiary">view details</ActionButton>
          <AddToBagButton
            defaultVariantId={defaultVariantId}
            icon="bag"
            menuItemId={menuItemId}
            as={ActionButton}
          >
            add to bag
          </AddToBagButton>
        </>
      ) : pickupEnabled ? (
        <ActionButton icon="bag">order now</ActionButton>
      ) : (
        <p className="text-xs mt-sm">
          <span className="py-xs">&nbsp;</span>
        </p>
      )}
    </div>
  );
};
